/* unplugin-vue-components disabled */import { render } from "./FormSwitch.vue?vue&type=template&id=5bde3712&ts=true"
import script from "./FormSwitch.vue?vue&type=script&lang=ts"
export * from "./FormSwitch.vue?vue&type=script&lang=ts"

import "./FormSwitch.vue?vue&type=style&index=0&id=5bde3712&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__